import React from 'react';

type Props = {
    children: React.ReactNode
}

function TableHead(props: Props) {
    const {children} = props
    
    return (
        <thead className="bg-gray-50">{children}</thead>
    );
}

export default TableHead;